import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { IdDescrittoriDiSezione } from '../../../configuration/nomi-descrittori-sezione';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { EXTENSIONS, mimeExtensionMap } from '../../file-preview/eml/eml-preview.component';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { Router } from '@angular/router';
import { AppData } from 'src/app/data-store';
import { UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';
import { DocPreviewUtilityService } from '../../file-preview/doc-preview-utility.service';
import { Subscription } from 'rxjs';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';


@Component({
    selector: 'ul [documenti_allegati_lista]',
  templateUrl: 'lista-documenti.component.html',
  styleUrls: ['lista-documenti.component.css'],
  host: { '[class.documentipratiche]': '\'true\'' }
})

export class ListaDocumentiComponent implements OnDestroy {
  @Input()
  writable: boolean;

  @Input()
  documenti: DocumentoAllegato[];

  @Input()
  fascicolo: FascicoloFull;

  @Input()
  sezione: any;

  @Input()
  subdoc: boolean;

  @Input()
  entityId: string = '';

  @Input()
  nomeCampoId: string = '';

  @Input()
  addDocFormTitle: string;

  @Output()
  onReturn = new EventEmitter();

  @Output()
  openModal = new EventEmitter();

  @Output()
  openHistoryModal = new EventEmitter();

  @Output()
  onOpenUpdateMetadatiModal = new EventEmitter();

  @Output()
  removDoc = new EventEmitter();

  @Input()
  isCensimenti: boolean = false;

  deleteFileSubscription: Subscription;

  private removeDocUrlArray: Array<string> = [];


  constructor(
    private helpersService: HelpersService, 
    private operationsService: OperationsService,
    private dialog: DialogService,
    private router: Router,
    private utilityFilePreview: DocPreviewUtilityService,
    private modalNotifyService: ModalNotifyService
  ) {
    this.helpersService = helpersService;
    this.dialog = dialog;
    this.removeDocUrlArray = this.getUrlRemoveDocument();
  }

  downloadFile(idDocumento) {
    this.helpersService.downloadDocument(idDocumento).subscribe();
  }

  openModalCallback(documento: DocumentoAllegato) {
    this.openModal.emit(documento);
  }

  openHistoryModalCallback(documento: DocumentoAllegato) {
    this.openHistoryModal.emit(documento);
  }

  openUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onOpenUpdateMetadatiModal.emit(documento);
  }

  deleteDoc(documento: DocumentoAllegato, entityId: string, nomeCampoId: string) {
    this.openDialogEliminaDocumento(documento);
  }

  openDialogEliminaDocumento(documento: DocumentoAllegato) {
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
          modalConfirm: {
            text: "Confermare la cancellazione del file?",
          },
          style: { width: "50%" },
          title: "Conferma",
        }
      });
    this.deleteFileSubscription = ref.afterClosed.subscribe(event => {
      if (event?.modalEvent === true) {
        this.removDoc.emit(documento);
      }
      this.deleteFileSubscription.unsubscribe();
    });
  }

  refresh(response) {
    this.onReturn.emit(response);
  }

  ngOnDestroy() {
    if (this.deleteFileSubscription) {
      this.deleteFileSubscription.unsubscribe();
    }
  }

  getUrlRemoveDocument(): Array<string> {
    let urlArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      urlArray['idSezioneControparti'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_CONTROPARTE;
      urlArray['idSezioneLegali'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_LEGALE_INCARICATO;
      urlArray['idSezioneAltreParti'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ALTRAPARTE;
      urlArray['idSezioneAtti'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ATTO;
      urlArray['idSezioneEsiti'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ESITO;
      urlArray['idSezioneParcelle'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PARCELLA;
      urlArray['idSezioneFatture'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_FATTURA;
      urlArray['idSezioneIncassi'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_INCASSO;
      urlArray['idSezionePagamenti'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PAGAMENTO;
      urlArray['idSezioneScadenze'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCADENZA;
      urlArray['idSezioneProveScritte'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PROVASCRITTA;
      urlArray['idSezioneTitoliEsecutivi'] = ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_TITOLO_ESECUTIVO;
    }
    return urlArray;
  }

  getIconByContentType(id: string) {
    return CssClassMapping.cssIconDocumentazioneAllegata[id];
  }

  canViewFile(documento: DocumentoAllegato){
    let maxPreviewSize = this.utilityFilePreview.findMaxSizeByContentype(documento.contentType);
    // controllo che il contenuto del file non superi la dimensione massima consentita
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return false;
    };
    return documento && 
    documento.nomeFile && (
      documento.nomeFile.includes(".pdf") || 
      documento.nomeFile.includes(".eml") || 
      documento.nomeFile.includes(".zip") ||
      documento.nomeFile.includes(".p7m")
    );
  }

  checkMaxLimitExceeded(documento: DocumentoAllegato):boolean {
    let maxPreviewSize = this.utilityFilePreview.findMaxSizeByContentype(documento.contentType);
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return true;
    }
    return false;
  }


  viewDoc(documento: DocumentoAllegato) {
    let mimeTypes = mimeExtensionMap;
    this.previewNavigate(documento, mimeTypes[documento.contentType]);
  }

  previewNavigate(documento: DocumentoAllegato, contentType: string) {
    let fullUrl = null;
    let urlTree = null;
    let urlSerialized = null;
    switch (contentType) {
      case EXTENSIONS.EML:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_EML_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.ZIP:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_ZIP_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.PDF:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.P7M:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW, documento.id, 'p7m']);
        break;
      default:
        this.helpersService.viewDoc(documento);
        break;
    }
    if(!urlTree) return;
    urlSerialized = this.router.serializeUrl(urlTree);
    fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}?nomeFile=${documento.nomeFile}`;
    window.open(fullUrl, '_blank');
  }

  

}
